import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import {CustomDateModel} from '../../../../../common/custom-date/entity/custom-date.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {LovValueOrCustomValueModel} from '../../../../../common/lov/lov-value/api/model/LovValueOrCustomValue.model';
import {ConsultationSummaryModel} from '../../../../consultation/consultation/api/model/consultationSummary.model';

export class MedicalRecordProblemModel implements SummaryModel {
    id: number;
    partner: PartnerSummaryModel;
    consultation: ConsultationSummaryModel;

    type: LovValueSummary;

    from: CustomDateModel;
    to: CustomDateModel;

    comment: string;
    description: string;
    treatment: string;
    involvedPartners: PartnerSummaryModel[] = [];

    locations: LovValueOrCustomValueModel[];
    whens: LovValueOrCustomValueModel[];

    permissions: PermissionsModel;
}
